
import { IonIcon } from '@ionic/react'
import { handLeft } from 'ionicons/icons'
import React from 'react'
import Page from '../components/Page'

export default class extends React.Component {
  render() {
    return (
      <Page title="Rune recipes" padding>
          <>3 El = 1 Eld </> <br />
          <>3 Eld  = 1 Tir </> <br />
          <>3 Tir  = 1 Nef </> <br />
          <>3 Nef  = 1 Eth </> <br />
          <>3 Eth  = 1 Ith </> <br />
          <>3 Ith  = 1 Tal </> <br />
          <>3 Tal  = 1 Ral </> <br />
          <>3 Ral  = 1 Ort </> <br />
          <>3 Ort  = 1 Thul </> <br /><br />

          <>3 Thul  + 1 Chipped Topaz = 1 Amn </> <br />
          <>3 Amn  + 1 Chipped Amethyst = 1 Sol </> <br />
          <>3 Sol  + 1 Chipped Sapphire = 1 Shael </> <br />
          <>3 Shael  + 1 Chipped Ruby = 1 Dol </> <br />
          3 Dol Runes + 1 Chipped Emerald = 1 Hel Rune  <br />
          3 Hel Runes + 1 Chipped Diamond = 1 Io Rune <br /> <br />

          3 Io Runes + 1 Flawed Topaz = 1 Lum Rune <br />
          3 Lum Runes + 1 Flawed Amythest = 1 Ko Rune <br />
          3 Ko Runes + 1 Flawed Sapphire = 1 Fal Rune <br />
          3 Fal Runes + 1 Flawed Ruby = 1 Lem Rune <br />
          3 Lem Runes + 1 Flawed Emerald = 1 Pul Rune <br />
          2 Pul Runes + 1 Flawed Diamond = 1 Um Rune <br /> <br />

          2 Um Runes + 1 Topaz = Mal Rune <br />
          2 Mal Runes + 1 Amethyst = Ist Rune <br />
          2 Ist Runes + 1 Sapphire = Gul Rune <br />
          2 Gul Runes + 1 Ruby = Vex Rune <br />
          2 Vex Runes + 1 Emerald = Ohm Rune <br />
          2 Ohm Runes + 1 Diamond = Lo Rune <br /> <br />
          2 Lo Runes + 1 Flawless Topaz = Sur Rune <br />
          2 Sur Runes + 1 Flawless Amethyst = Ber Rune <br />
          2 Ber Runes + 1 Flawless Sapphire = Jah Rune <br />
          2 Jah Runes + 1 Flawless Ruby = Cham Rune <br />
          2 Cham Runes + 1 Flawless Emerald = Zod Rune  <br />

      </Page>
    )
  }
}